import { decode } from 'base64-arraybuffer';
import { NewImageDto, ProfileDto } from 'gleblu-socket-api';
import { NewProfileDto } from 'gleblu-socket-api/lib/dataTransferObject/placeDtos/ProfileDto';

import PlaceProfile, { PlaceImage } from '../interfaces/PlaceProfile';

export function fromDto(profileDto: ProfileDto): PlaceProfile {
  const { uuid, placeUuid, placeImages } = profileDto;
  const pictures = placeImages.map((placeImageDto) => {
    const { url, fileExtension, isProfilePicture, ...others } = placeImageDto;
    const placeImage: PlaceImage = { ...others, fileExtension, url };
    return placeImage;
  });
  const profilePicture = placeImages.findIndex((image) => image.isProfilePicture);
  const profilePictureUuid = profilePicture >= 0 ? pictures[profilePicture].uuid : null;
  return {
    uuid,
    placeUuid,
    oldProfilePictureUuid: profilePictureUuid,
    profilePictureUuid,
    oldPictures: pictures,
    newPictures: [],
    deletedPictures: [],
  };
}

export function toDto(profile: PlaceProfile): NewProfileDto {
  const { uuid, placeUuid, newPictures, deletedPictures, profilePictureUuid, oldProfilePictureUuid } = profile;

  const newPlaceImages: NewImageDto[] = newPictures.map((picture) => {
    const base64str = picture.img.split(',')[1];
    const byteArray = decode(base64str);

    return {
      ...picture,
      img: byteArray,
      isProfilePicture: picture.uuid === profilePictureUuid,
    };
  });

  const newProfileDto: NewProfileDto = {
    uuid,
    placeUuid,
    newPlaceImages,
    deletedPlaceImages: deletedPictures,
  };

  if (oldProfilePictureUuid !== profilePictureUuid) {
    if (oldProfilePictureUuid !== null && !newProfileDto.deletedPlaceImages.includes(oldProfilePictureUuid))
      newProfileDto.oldProfilePictureUuid = oldProfilePictureUuid;
    newProfileDto.newProfilePictureUuid = profilePictureUuid;
  }

  return newProfileDto;
}
